import React from "react";

//CSS
import "./warehouseCreateCard.css";

//Animations
import { motion } from "framer-motion";
import { RevealVariants } from "../Other Components/anims";

function WarehouseCreateCard({ onClick, className }) {
  return (
    <motion.div
      initial="hiddenFade"
      whileInView="shownFast"
      whileHover={"hover"}
      onClick={onClick}
      viewport={{ once: RevealVariants.showOnce }}
      variants={RevealVariants}
      className={"warehouse-create-card" + " " + className}
    >
      <p className="warehouse-create-card-plus"></p>
    </motion.div>
  );
}

export default WarehouseCreateCard;
